import React, { useEffect, useRef, useState } from 'react'
import * as image from "../../../src/resources/images";
import { getCapitalized, getChildrenSort, getName, getProfileName, getToolTip, textTrim } from '../../utils/helper';
import { useDispatch, useSelector } from 'react-redux';
import { PATHS } from '../../utils';
import { getSettingData, getUserByUsername, logoutAction, newsLetterApi } from '../../redux/actions/APIs';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useForm } from 'react-hook-form';
import { MSG } from '../../utils/Messages';
import { EMAIL_REGEX, NAME_REGEX } from '../../utils/Regex';
import { resetEmailResponse, resetResponse } from '../../redux/actions';
import { toast } from 'react-toastify';
import Success from '../notifications/Success';
const NewLetterModule = () => {
    const dispatch = useDispatch();
    const { loggedInUser, validateUser, newsLetterResp} = useSelector((state) => state.collections);
    const {
            register,
            control,
            handleSubmit,
            watch,
            getValues,
            setValue,
            reset,
            setError,
            clearErrors,
            unregister,
            formState: { errors },
        } = useForm({ mode: "onTouched" });

    const isValidEmail = (email) => {
            if (EMAIL_REGEX.test(email)) {
                return true;
            }
            return false;
        };
    const handleInvite = (e) => {
            if (loggedInUser?.username.toLowerCase() === e.target.value.toLowerCase()) {
                setError("username", { type: "custom", message: MSG.INVITEMSG });
            
            } else {
                clearErrors("username");
            }
    
            let emailAddress = e.target.value;
            let formData = {
                email: emailAddress,
            };
    
            if (isValidEmail(emailAddress)) {
                dispatch(getUserByUsername(formData));
            }
    
            if (emailAddress?.length === 0) {
                dispatch(resetEmailResponse());
            }
        };
    
    const _onSubmit = (values)=>{
        if (validateUser && validateUser?.message) {
			return false;
		}
        values.status = "Newsletter Account";
       dispatch(newsLetterApi(values));
       reset();
    }

    // useEffect(() => {
	// 	if (newsLetterResp && newsLetterResp?.success) {
	// 		toast.info(<Success response={newsLetterResp} />, {});
    //         dispatch(newsLetterApi());
           
	// 	}
	// }, [newsLetterResp]);
    return (
        <div class="footer-area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div className="subscription_footer flexone pb-4">
                            <div className="w-50 pr-4">
                                <h1 className="fw-600 pb-3">Subscribe to Our Newsletter</h1>
                                <p>Stay in the loop—subscribe to the Bloomster newsletter for expert tips, upcoming course updates, and insights to help your child thrive.</p>
                            </div>
                            <form
									name="newslettersignup"
                                    className="w-50"
									onSubmit={handleSubmit(_onSubmit)}
								>
                                    <div className="w-100 flexone flex-wrap justify-content-between align-items-baseline">
                                <div className='input-group w-48 mb-3'>
                                    {/* <label className='m-0'>
							  First Name<span className='mandatoryField'>*</span>
							</label> */}
                                    <div className='form-group'>
                                        <input
                                            type='text'
                                            className={`form-control ${errors.firstName ? "is-invalid" : ""
                                                }`}
                                            {...register("firstName", {
                                                // required: {
                                                //     value: true,
                                                //     message: MSG.FNAMEREQ,
                                                // },
                                                pattern: {
                                                    value: NAME_REGEX,
                                                    message: "First name " + MSG.ALPHAREQ,
                                                },
                                                maxLength: {
                                                    value: 15,
                                                    message: MSG.MAX15CHREQ,
                                                },
                                            })}
                                            placeholder="First Name"
                                            required={true}
                                        />
                                        <div className='invalid-feedback'>
                                            {errors?.firstName?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className='input-group w-48 mb-3'>
                                    {/* <label className='m-0'>
											Last Name<span className='mandatoryField'>*</span>
										  </label> */}
                                    <div className='form-group'>
                                        <input
                                            type='text'
                                            className={`form-control ${errors.lastName ? "is-invalid" : ""
                                                }`}
                                            {...register("lastName", {
                                                // required: {
                                                //     value: true,
                                                //     message: MSG.FNAMEREQ,
                                                // },
                                                pattern: {
                                                    value: NAME_REGEX,
                                                    message: "Last Name " + MSG.ALPHAREQ,
                                                },
                                                maxLength: {
                                                    value: 15,
                                                    message: MSG.MAX15CHREQ,
                                                },
                                            })}
                                            placeholder="Last Name"
                                            required={true}
                                        />
                                        <div className='invalid-feedback'>
                                            {errors?.lastName?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className='input-group subscriptionemail pr-1 p-0'>
                                    {/* <label className='m-0'>
														  Email<span className='mandatoryField'>*</span>
														</label> */}
                                    <div className='form-group'>
                                        <input
                                            type='email'
                                            className={`form-control ${errors.email || validateUser?.message ? "is-invalid" : ""
                                                }`}
                                            {...register("email", {
                                                onChange: (e) => handleInvite(e),
                                                // required: {
                                                //     value: true,
                                                //     message: MSG.EMAILREQ,
                                                // },
                                                pattern: {
                                                    value: EMAIL_REGEX,
                                                    message: MSG.INVEMAILREQ,
                                                },
                                                maxLength: {
                                                    value: 100,
                                                    message: MSG.MAX100CHREQ,
                                                },
                                            })}

                                            onBlur={(e) => handleInvite(e)}
                                            placeholder="Email"
                                            required={true}
                                        />
                                        <div className='invalid-feedback'>
                                            {errors?.email?.message ? errors?.email?.message : validateUser?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group w-auto text-right">
                                    <button type="submit" className="mybutton">Subscribe Now</button>
                                </div>
                            </div>
                            </form>
                            
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-lg-4 col-md-4">
                        <div class="single-footer-widget">
                            <a class="logo" href="https://bloomster.com/">
                                <img src="https://softwarehouse.today/projects/bloomster/wp-content/uploads/2025/04/bloomster-logo-updated.png" alt="Bloomster" />
                            </a>
                            <p>Copyright:  © 2025 Bloomster</p>
                        </div>

                    </div>
                    <div class="single-footer-widget col-lg-8 col-md-8 widget_nav_menu">
                        {/* <h3>Resources</h3> */}
                        <div class="menu-resources-container"><ul id="menu-resources" class="">
                            <li id="menu-item-7560" class="menu-item"><a href="https://bloomster.com/about-us">About</a></li>
                            <li id="menu-item-6587" class="menu-item "><a href="https://bloomster.com/course-library">Courses</a></li>
                               <li id="menu-item-6589" class="menu-item "><a href="https://bloomster.com/online-platform">For Parent</a></li>
                            <li id="menu-item-6589" class="menu-item "><a href="https://bloomster.com/classroom">For Schools</a></li>
                            <li id="menu-item-6587" class="menu-item "><a href="https://bloomster.com/blog">Blog</a></li>
                            <li id="menu-item-6588" class="menu-item "><a href="https://bloomster.com/ebook-library">EBooks</a></li>
                         
                            <li id="menu-item-6589" class="menu-item "><a href="https://bloomster.com/termsandprivacypolicy">Privacy</a></li>
                            <li id="menu-item-6589" class="menu-item "><a href="https://bloomster.com/termsandprivacypolicy">Term</a></li>

                        </ul>
                            <div class="single-footer-widget  widget_ecademy_contact_info w-100">
                                {/* <h3>Contact Information</h3>     */}
                                {/* <ul class="footer-contact-info">
          <li><i class="fa-regular fa-envelope"></i> <a href="mailto:contact@bloomster.com">contact@bloomster.com</a>  </li>
         </ul> */}
                                <ul class="social-link text-right">
                                    <li>
                                        <a class="d-block facebook" target="_blank" href="https://www.facebook.com/bloomsterlearning"> <i class="fa-brands fa-facebook"></i></a>
                                    </li>

                                    <li>
                                        <a class="d-block" target="_blank" href="https://www.linkedin.com/company/bloomsterlearning"><i class="fa-brands fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a class="d-block instagram" target="_blank" href="https://www.instagram.com/bloomsterlearning"><i class="fa-brands fa-instagram"></i></a>
                                    </li>
                                    <li>
                                        <a class="d-block" target="_blank" href="https://www.tiktok.com/@bloomster.learning"> <i class="fa-brands fa-tiktok"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* <div class="single-footer-widget col-lg-3 col-md-3 widget_nav_menu">
        <h3>Quick Links</h3><div class="menu-quick-links-container">
        <ul id="menu-quick-links" class="">
          <li id="menu-item-6583" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6583"><a href="https://bloomster.com/course-library">Courses</a></li>
          <li id="menu-item-7561" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-7561"><a href="https://bloomster.com/online-platform">How Bloomster Works</a></li>
          <li id="menu-item-6585" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6585"><a href="https://bloomster.com/pricing">Pricing</a></li>
          <li id="menu-item-6586" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6586"><a href="https://bloomster.com/classroom">Bloomster for Schools</a></li>
        </ul>
        </div>
      </div> */}


                </div>
                {/* <div class="footer-bottom-area">
							<div class="row align-items-center">
								<div class="col-lg-6 col-md-6">
																			<p>2025 Bloomster. All Rights Reserved.</p>
																	</div>

								<div class="col-lg-6 col-md-6">
									<ul id="menu-footer-menu" class=""><li id="menu-item-6581" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6581"><a href="https://bloomster.com/termsandprivacypolicy">Privacy Policy</a></li>
<li id="menu-item-6582" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-6582"><a href="https://bloomster.com/termsandprivacypolicy">Terms of Use</a></li>
</ul>								</div>
							</div>
						</div> */}
            </div>
        </div>
    )
}
export default NewLetterModule;